const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the add video component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('addManageVtt', ['Application', 'S3Uploads', 'Upload', '$translate', function(Application, S3Uploads, Upload, $translate) {
    return {
      restrict: 'E',
      scope: {
        instructions: '=',
        updateVideo: '&',
        video: '='
      },
      template: require('../../../templates/directives/cms/add-manage-vtt.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.translations = {};
          self.locales = Application.locales;

          self.uploaderId = 'add-vtt-' + new Date().valueOf();
          self.browseFile = function() {
            document.getElementById(self.uploaderId).click();
          };

          self.localeName = function(key) {
            for (var i = 0; i < self.locales.length; i ++) {
              if (self.locales[i].value === key) {
                return self.locales[i].name;
              }
            }
            return '--';
          };

          $scope.$watch('addManageVtt.uploadedFile', function(newVal, oldVal) {
            if(newVal && !newVal.$error) {
              self.onFileSelect(self.uploadedFile);
            }
          });

          self.currentFile = {}

          self.onFileSelect = function(uploaded) {
            self.fileName = uploaded.name;
            if(uploaded.size > 10000000) {
              Application.messaging.addMessage({type: 'error', text: self.translations['edit.videos.vtt_limit'], duration: 5});
              return;
            }
            if(uploaded.type === '') {
              uploaded.type = 'application/octet-stream';
            }

            S3Uploads.filePolicy({fileName: uploaded.name, contentType: uploaded.type}, function(data) {
              var cloudFrontLink = data.CloudFrontLink;
              Upload.upload({
                url: 'https://' + data.Bucket + '.s3.amazonaws.com/',
                headers: {'Remove-auth': 'yes'},
                method: 'POST',
                data: {
                  key: data.Key,
                  'Content-Type': data.ContentType,
                  AWSAccessKeyId: data.AWSAccessKeyId,
                  'success_action_status': '201',
                  policy: data.S3Policy,
                  signature: data.S3Signature
                },
                file: uploaded
              }).progress(function(evt) {
                var percent = parseInt(100.0 * evt.loaded / evt.total, 10);
                self.loadingBar = true;
                self.loadingPercent = percent;
                self.progress = {'width': parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10) + '%'};
              }).success(function(data) {
                self.uploadedFile = null;
                document.getElementById(self.uploaderId).value = "";
                self.loadingBar = false;
                self.loadingPercent = 0;
                self.currentFile.url = cloudFrontLink;
                self.setLocale = true;
              }).catch(function(error) {
                console.log('upload error', error);
              });
            }, function(error) {
              Application.messaging.addMessage({type: 'error', text: error.message, duration: 5});
            });

          };

          self.addToVideo = function() {
            if (!self.currentFile.url || !self.currentFile.locale) {
              return;
            }
            if ($scope.video && $scope.video.vtt_files) {
              var error;
              $scope.video.vtt_files.forEach(function(file) {
                if (file.locale && file.locale === self.currentFile.locale) {
                  error = file.locale;
                }
              });
              if (error) {
                Application.messaging.addMessage({text: self.translations['edit.videos.locale_in_use'], type: 'error', duration: 7});
                return;
              }
            }
            // Perhaps expand kind options if needed (subtitles, etc.)
            self.currentFile.kind = 'captions';
            $scope.updateVideo({addition: self.currentFile});
          };

          self.remove = function(file) {
            for (var i = 0; i < $scope.video.vtt_files.length; i++) {
              if ($scope.video.vtt_files[i].locale && $scope.video.vtt_files[i].locale === file.locale) {
                $scope.video.vtt_files.splice(i, 1);
                break;
              }
            }

            $scope.updateVideo({addition: 'removed'});
          };

          $translate([
            'edit.videos.vtt_limit',
            'edit.videos.locale_in_use'
          ]).then(function(translations) {
            self.translations = translations;
          });

          $scope.$watch('video.vtt_files', function(newVal, oldVal) {
            if (newVal !== oldVal) {
              self.loadingBar = false;
              self.setLocale = false;
              self.currentFile = {};
            }
          }, true);

        }],
      controllerAs: 'addManageVtt'
    };
  }]);